import dayjs from 'dayjs';
import 'dayjs/locale/en-gb';
import 'dayjs/locale/en';

// Detect browser locale
const getBrowserLocale = () => {
  if (navigator.languages && navigator.languages.length) {
    return navigator.languages[0];
  }
  return navigator.language || 'en-GB';
};

// Map browser locales to dayjs locales
const getDayJSLocale = (browserLocale) => {
  const localeMap = {
    'en-GB': 'en-gb',
    'en-US': 'en',
  };
  
  return localeMap[browserLocale] || browserLocale.split('-')[0] || 'en-gb';
};

// Get date format based on locale
const getDateFormat = (locale) => {
  const formatMap = {
    'en-gb': 'DD/MM/YYYY',
    'en': 'MM/DD/YYYY',
  };
  
  return formatMap[locale] || 'DD/MM/YYYY';
};

// Helper function to parse dates (handles both ISO and formatted strings)
const parseDate = (dateString) => {
  if (!dateString) return null;
  
  // Check if it's ISO format (contains 'T' or ends with 'Z')
  if (typeof dateString === 'string' && (dateString.includes('T') || dateString.endsWith('Z'))) {
    const parsed = dayjs(dateString); // ISO format - dayjs auto-detects
    return parsed.isValid() ? parsed : null;
  }
  
  // Otherwise, parse with the configured dateFormat
  const parsed = dayjs(dateString, dateFormat);
  return parsed.isValid() ? parsed : null;
};

const browserLocale = getBrowserLocale();
const dayjsLocale = getDayJSLocale(browserLocale);
const dateFormat = getDateFormat(dayjsLocale);

dayjs.locale(dayjsLocale);

export { dayjsLocale, dateFormat, browserLocale, parseDate };